import { render, staticRenderFns } from "./UpcomingFeatureDialog.vue?vue&type=template&id=0528eb74&"
import script from "./UpcomingFeatureDialog.vue?vue&type=script&lang=js&"
export * from "./UpcomingFeatureDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports